import { useEffect, useState, useRef } from 'react';
import { userManager } from './userManager';
import { replaceWith } from '@utils/navigation';
import Loading from '@components/common/Loading';
import Error from '@components/common/Error';

const LogoutCallback = () => {
  const [error, setError] = useState<string | null>(null);
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) {
      return;
    }

    const handleLogoutCallback = async () => {
      try {
        await userManager.signoutRedirectCallback();
        await userManager.removeUser();
        hasProcessed.current = true;
        replaceWith('/');
      } catch (err) {
        console.error('LogoutCallback: Error processing logout callback:', err);
        const errorMessage =
          (err as { message?: string } | null)?.message ||
          (err as { error?: string } | null)?.error ||
          String(err);
        setError(errorMessage);
      }
    };

    handleLogoutCallback();
  }, []);

  if (error) {
    return <Error message={`Logout failed: ${error}`} />;
  }

  return <Loading message='Completing logout...' />;
};

export default LogoutCallback;
